<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md(v-for="section in sections" :key="section.id" v-if="section.edges.length")
    .grid
      .column.is-widescreen-4
        AppTitle.u-mb-xs(:title="$t(section.title)" tag="h2")
        p.u-text-lg.u-mb-xs {{ $t(`${section.title}Desc`) }}
        .u-mb-mi
          AppLink(:to="section.url" class="button-link hide-desktop" :title="$t('viewMore')") {{ $t('viewMore') }}

      .column.is-widescreen-8
        .grid.is-middle
          .column.is-tablet-6(v-for="{ node } in section.edges" :key="node.id")
            AppCard.is-large(:img="node.thumb" :excerpt="node.description" :title="node.title" :url="`${section.url}/${node.slug}`")
        AppLink(:to="section.url" class="button-link show-desktop" :title="$t('viewMore')") {{ $t('viewMore') }}

  .u-mb-mi

</template>

<script>
import { Highlights } from '~/graphql/Shame.gql';
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  meta: {
    logoText: 'highlights'
  },
  head: generateSeoMeta(
    {
      title: 'pageTitle',
      description: 'pageDesc'
    },
    { i18n: true }
  ),
  async asyncData({ app }) {
    try {
      const { data } = await app.$api.query({
        query: Highlights
      });

      return {
        sections: Object.keys(data)
          .filter(key => !!data[key].edges.length)
          .map(key => {
            let url = `/${key}`;
            if (/code|business|design|technology/.test(key)) {
              url = `/labs/${key}`;
            }

            return {
              title: key,
              url,
              edges: data[key].edges
            };
          })
      };
    } catch (err) {
      console.error(err);
    }
  }
};
</script>

<style lang="stylus">
.hide-desktop
  +mq($until: 'desktop')
    display: none

.show-desktop
  +mq($from: 'desktop')
    display: none
</style>

<i18n>
{
  "en": {
    "pageTitle": "Highlights",
    "pageDesc": "Discover the latest by Baianat and get a sneak peek into what's happening.",
    "mantra":"Get into |the know",
    "blog": "Blog",
    "blogDesc": "Get game changing tips and hacks for your business and keep up with the latest trends and technologies.",
    "books": "Books",
    "booksDesc":"Explore Baianat library of books and guides. Get to know the what and how of design, business, code and technology.",
    "business":"Business",
    "businessDesc":"Strategy, Planning, Innovation, Business, Marketing, Story telling, Social media.",
    "design":"Design",
    "designDesc":"Product Design, User experience, Interaction, Design systems, Typography",
    "code":"Code",
    "codeDesc":"Development, Open source, Frameworks, Plugins, Artificial intelligence.",
    "technology":"Technology",
    "technologyDesc":"Artificial Intelligence, IoT, Extended Reality, Robotics, Big Data and Analytics.",
    "press":"Press",
    "pressDesc": "Check the latest breaking news and press releases from inside Baianat and keep up with the updates moment by moment."
  },
  "ar": {
    "pageTitle": "مقتطفات",
    "pageDesc": "اكتشف آخر ما قامت به بيانات واحصل على نظرة خاطفة على كل ما يحدث.",
    "mantra": "اكتشف كل |جديد. ",
    "blog": "المدونة",
    "blogDesc": "احصل على النصائح التى تساعدك على تطوير وتنمية أعمالك، وواكب أحدث الاتجاهات والتكنولوجيا التي تساعدك في ازدهارها.",
    "books": "الكتب",
    "booksDesc":"اكتشف مكتبة بيانات للكتب المتنوعة و التي تتضمن مواضيع حول التصميم و الأعمال التجارية و البرمجة والتكنولوجيا والأنيميشن.",
    "business":"بيزنس",
    "businessDesc":"الاستراتيجية و التخطيط و الابتكار و الأعمال التجارية والتسويق ورواية القصص ووسائل التواصل الإجتماعي.",
    "design":"تصميم",
    "designDesc":"تصميم المنتجات، وتجربة المستخدم، والتصميمات التفاعلية، وأنظمة التصميم، والتايبوغرافي وتصميم الهوية التجارية.",
    "code":"برمجة",
    "codeDesc":"برمجة المواقع والتطبيقات والحلول البرمجية والمصادر المفتوحة والإضافات وإطارات العمل والذكاء الإصطناعي.",
    "technology":"تكنولوجيا",
    "technologyDesc":"الذكاء الاصطناعي و إنترنت الأشياء والآلية و البيانات الضخمة والتحليلات والواقع المعزز والواقع الافتراضي.",
    "press":"الصحافة",
    "pressDesc": "تعرف على أحدث الأخبار العاجلة و التصريحات الصحفية التي تخص بيانات لتعرف كل ما يدور بداخلها لحظة بلحظة كأنك في وسط الفريق."
  }
}
</i18n>
